import styled from 'styled-components'

export const Label = styled.label`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #202020;
  display: flex;
  justify-content: space-between;
  align-items: center;

  section {
    color: #202020;
  }

  div {
    cursor: pointer;
  }

  svg {
    margin-left: 8px;
  }

  > span {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgba(32, 32, 32, 0.5);
  }
`

export const TextAreaContainer = styled.div`
  padding: ${(p) => {
    return p.description ? '16px 16px 48px 16px' : '16px'
  }};
  padding-right: 6px;
  width: 100%;
  background: ${(p) => {
    return p.disabled ? 'rgba(250, 250, 250, 1)' : '#ffffff'
  }};
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-sizing: border-box;

  &:hover {
    border: ${(p) => {
    return p.disabled ? '' : '1px solid #0aa1f4'
  }};
    box-shadow: ${(p) => {
    return p.disabled ? '' : '0px 1px 2px rgba(32, 32, 32, 0.05), 0px 0px 0px 4px rgba(10, 161, 244, 0.1)'
  }};
    transition: box-shadow 0.1s ease-in-out;
  }

  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  margin-bottom: ${(p) => {
    return p.error ? '0' : '32px'
  }};
  border: ${(props) => {
    return props.error ? '1px solid #E11900' : '1px solid rgba(32, 32, 32, 0.2)'
  }};
`

export const TextArea = styled.textarea`
  font-family: Inter;
  width: 100%;
  height: ${(p) => {
    return p.height
  }};
  resize: ${(p) => {
    return p.resize
  }};
  border: none;
  background: ${(p) => {
    return p.disabled ? 'rgba(250, 250, 250, 1)' : '#ffffff'
  }};

  max-height: ${(p) => {
    return p.maxHeight
  }};

  &:focus {
    outline: none;
  }

  font-size: 14px;
  line-height: 20px;
  color: #202020;
  -webkit-text-fill-color: ${(p) => {
    return p.disabled ? '#202020' : '#202020'
  }};
  opacity: ${(p) => {
    return p.disabled ? 1 : undefined
  }};

  ::placeholder {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: rgba(32, 32, 32, 0.7);
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(32, 32, 32, 0.2);
    height: 48px;
    border-radius: 4px;
  }
  padding-right: 6px;
`

export const TextAreaDescription = styled.div`
  position: absolute;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.5);
  bottom: 16px;
  left: 16px;
`
export const TextAreaCounter = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${(p) => (p.limitReached ? '#E11900' : 'rgba(32, 32, 32, 0.6)')};
  text-align: right;
`;

export const TextAreaError = styled.div`
  color: #e11900;
  margin-top: ${(p) => {
    return p.marginTopError
  }};
  line-height: 16px;
  margin-bottom: 32px;
`
